export const OtherMenu10 = () => {
    return (
        <span>
            <svg
                className="active-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <g clipPath="url(#clip0_10727_39258)">
                    <path
                        d="M1.25781 20.9341L22.7383 20.9341"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M3.44141 8.13184L3.44141 20.9351"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M1.53125 9.69516L9.34669 2.86448C10.8542 1.54688 13.1038 1.54688 14.6113 2.86448L22.4268 9.69516"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.5577 20.9355V8.13219L13.8531 2.04297H10.3055L3.44035 8.13218L3.30859 20.9355H21.5577ZM9.53381 8.20769C8.63678 8.20769 7.79375 8.59346 7.18496 9.25131C6.5786 9.90655 6.25 10.7798 6.25 11.6756C6.25 12.5714 6.5786 13.4446 7.18496 14.0998C7.19627 14.112 7.20788 14.124 7.21977 14.1356L11.3009 18.1262C11.6895 18.5063 12.3105 18.5063 12.6991 18.1262L16.7802 14.1356C16.7921 14.124 16.8037 14.112 16.815 14.0998C17.4214 13.4446 17.75 12.5714 17.75 11.6756C17.75 10.7798 17.4214 9.90655 16.815 9.25131C16.2063 8.59346 15.3632 8.20769 14.4662 8.20769C13.5756 8.20769 12.7382 8.58794 12.1305 9.23717L12 9.36851L11.8695 9.23716C11.2617 8.58793 10.4244 8.20769 9.53381 8.20769ZM8.65286 10.6097C8.90067 10.3419 9.21944 10.2077 9.53381 10.2077C9.84818 10.2077 10.1669 10.3419 10.4148 10.6097C10.4228 10.6184 10.431 10.627 10.4394 10.6354L11.2906 11.4921C11.4784 11.681 11.7337 11.7873 12 11.7873C12.2663 11.7873 12.5216 11.681 12.7094 11.4921L13.5606 10.6354C13.569 10.627 13.5772 10.6184 13.5852 10.6097C13.8331 10.3419 14.1518 10.2077 14.4662 10.2077C14.7806 10.2077 15.0993 10.3419 15.3471 10.6097C15.5974 10.8801 15.75 11.2623 15.75 11.6756C15.75 12.0807 15.6033 12.4561 15.3617 12.7255L12 16.0126L8.63832 12.7255C8.39673 12.4561 8.25 12.0807 8.25 11.6756C8.25 11.2623 8.40263 10.8801 8.65286 10.6097Z"
                        fill="white"
                    />
                </g>
            </svg>

            <svg
                className="base"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <g id="Frame" opacity="0.3" clipPath="url(#clip0_11224_25921)">
                    <path
                        id="Vector"
                        d="M1.25781 20.9341L22.7383 20.9341"
                        stroke="#1A1A1A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_2"
                        d="M3.44141 8.13184L3.44141 20.9351"
                        stroke="#1A1A1A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_3"
                        d="M20.5391 20.9351L20.5391 8.13184"
                        stroke="#1A1A1A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_4"
                        d="M1.53125 9.69522L9.34669 2.86454C10.8542 1.54694 13.1038 1.54694 14.6113 2.86454L22.4268 9.69522"
                        stroke="#1A1A1A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Vector_5"
                        d="M12 17.4112L16.0811 13.4206C16.5094 12.9578 16.75 12.33 16.75 11.6755C16.75 11.021 16.5094 10.3933 16.0811 9.93047C15.6528 9.46765 15.0719 9.20764 14.4662 9.20764C13.8605 9.20764 13.2796 9.46765 12.8513 9.93047L12 10.7872L11.1487 9.93047C10.7204 9.46765 10.1395 9.20764 9.53381 9.20764C8.92811 9.20764 8.34721 9.46765 7.91891 9.93047C7.49062 10.3933 7.25 11.021 7.25 11.6755C7.25 12.33 7.49062 12.9578 7.91891 13.4206L12 17.4112Z"
                        stroke="#1A1A1A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_7650_34478">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
};
